export class PunchMatchRepository {
    private httpService: IHttpService
    constructor(instance: IHttpService) {
        this.httpService = instance;
    }

    async getPunchMatch({employee_id, start_date, end_date}: {employee_id: number, start_date: string, end_date: string}): Promise<PunchMatch[]> {
        try {
            const response = await this.httpService.get<TKResponse<PunchMatch[]>>('/punch_match', {
                params: {
                    employee_id: employee_id,
                    start_date: start_date,
                    end_date: end_date
                }
            });
            return response.data;
        } catch (error) {
            console.error('Error al obtener los punch_matches:', error);
            throw error;
        }
    }
}